import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership-type/:membershipTypeId/zone-rules/:ruleId/`;
type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    membershipTypeId: string;
    ruleId: string;
}
const mutationFn = ({ parkingId, membershipTypeId, ruleId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, membershipTypeId, ruleId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteMembershipTypeZoneRule };
